'use es6';

import PropTypes from 'prop-types';
import { Component } from 'react';
import { connect } from 'react-redux';
import Immutable from 'immutable';
import UIButton from 'UIComponents/button/UIButton';
import UIIcon from 'UIComponents/icon/UIIcon';
import FormattedMessage from 'I18n/components/FormattedMessage';
import ChooseEmailAddressesForExportModal from './modals/ChooseEmailAddressesForExportModal';
import { exportFiles } from '../actions/Files';
import { exportSelectedFilesAndFolders } from '../actions/Bulk';
import { getSelectedFilesAndFolders } from '../selectors/Selection';
import { getIsUserSuperAdmin, selectIsUngatedForHideExportForNonSuperAdmins } from 'FileManagerCore/selectors/Auth';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
class ExportFilesAndButtonsContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isChooseEmailModalOpen: false,
      emails: [],
      isExportButtonDisabled: true
    };
    this.handleExport = this.handleExport.bind(this);
    this.handleSelectChange = this.handleSelectChange.bind(this);
    this.handleCloseModal = this.handleCloseModal.bind(this);
  }
  handleExport() {
    const {
      onExportFiles,
      onExportSelectedFilesAndFolders,
      selectedFilesAndFolders,
      isExportingSelection
    } = this.props;
    const {
      emails
    } = this.state;
    if (isExportingSelection) {
      onExportSelectedFilesAndFolders(emails.join(','), selectedFilesAndFolders);
    } else {
      onExportFiles(emails.join(','));
    }
    this.setState({
      isChooseEmailModalOpen: false
    });
  }
  handleSelectChange({
    target: {
      value
    }
  }) {
    this.setState({
      emails: value,
      isExportButtonDisabled: value.length < 1
    });
  }
  handleCloseModal() {
    this.setState({
      isChooseEmailModalOpen: !this.state.isChooseEmailModalOpen
    });
  }
  render() {
    const {
      isExportingSelection,
      isUserSuperAdmin,
      isUngatedForHideExportForNonSuperAdmins
    } = this.props;
    const {
      isExportButtonDisabled
    } = this.state;
    if (isUngatedForHideExportForNonSuperAdmins && !isUserSuperAdmin) {
      return null;
    }
    return /*#__PURE__*/_jsxs("span", {
      children: [/*#__PURE__*/_jsxs(UIButton, {
        size: "small",
        use: "link",
        onClick: this.handleCloseModal,
        children: [/*#__PURE__*/_jsx(UIIcon, {
          name: "download"
        }), /*#__PURE__*/_jsx(FormattedMessage, {
          message: `FileManagerDashboard.actions.${isExportingSelection ? 'exportSelection' : 'export'}`
        })]
      }), this.state.isChooseEmailModalOpen && /*#__PURE__*/_jsx(ChooseEmailAddressesForExportModal, {
        handleCloseModal: this.handleCloseModal,
        handleSelectChange: this.handleSelectChange,
        handleExport: this.handleExport,
        isExportButtonDisabled: isExportButtonDisabled
      })]
    });
  }
}
ExportFilesAndButtonsContainer.propTypes = {
  onExportFiles: PropTypes.func.isRequired,
  onExportSelectedFilesAndFolders: PropTypes.func.isRequired,
  isExportingSelection: PropTypes.bool.isRequired,
  selectedFilesAndFolders: PropTypes.instanceOf(Immutable.Map).isRequired,
  isUserSuperAdmin: PropTypes.bool.isRequired,
  isUngatedForHideExportForNonSuperAdmins: PropTypes.bool.isRequired
};
ExportFilesAndButtonsContainer.defaultProps = {
  isExportingSelection: false
};
const mapDispatchToProps = {
  onExportFiles: exportFiles,
  onExportSelectedFilesAndFolders: exportSelectedFilesAndFolders
};
const mapStateToProps = state => {
  return {
    selectedFilesAndFolders: getSelectedFilesAndFolders(state),
    isUserSuperAdmin: getIsUserSuperAdmin(state),
    isUngatedForHideExportForNonSuperAdmins: selectIsUngatedForHideExportForNonSuperAdmins(state)
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(ExportFilesAndButtonsContainer);